import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  InjectionToken,
  Input
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { startWith, switchMap } from 'rxjs';
import { AssignedToService, Assignee } from './assigned-to-service-interface';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { NgFor, AsyncPipe } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';

export const AssignToServiceIJ = new InjectionToken('AssignToService');

@Component({
    selector: 'app-assigned-to',
    templateUrl: './assigned-to.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: AssignedToComponent,
            multi: true
        }
    ],
    standalone: true,
    imports: [MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatAutocompleteTrigger, MatAutocomplete, MatOption, NgFor, MatIconButton, MatTooltip, MatIcon, AsyncPipe]
})
export class AssignedToComponent implements ControlValueAccessor {
  filter = new FormControl<string>(null);
  editMode = false;
  options$ = this.filter.valueChanges.pipe(
    startWith(''),
    switchMap((search) => this.assignToService.filterOptions(search))
  );
  unassignedUser: Assignee = { label: 'Unassigned', value: null };

  @Input() label = 'Assigned to';
  @Input() allowUnassigned = true;
  value: Assignee;

  onChange = (value: any) => {};
  onTouched = () => {};

  constructor(
    @Inject(AssignToServiceIJ) public assignToService: AssignedToService
  ) {}

  toggleEdit() {
    this.editMode = !this.editMode;
    this.filter.patchValue(this.value?.label);
  }

  save(value: Assignee) {
    this.assignToService.saveAssignee(value).subscribe(() => {
      this.value = value;
      this.onChange(value.value);
      this.editMode = false;
    });
  }

  displayWith(value: Assignee) {
    if (!value) {
      return '';
    }
    return value.label;
  }

  writeValue(obj: any): void {
    if (isNaN(obj)) {
      this.value = this.unassignedUser;
      return;
    }
    if (!obj) {
      this.value = this.unassignedUser;
      return;
    }
    this.assignToService
      .getSelectedAssignee(obj as number)
      .subscribe((assignee) => {
        this.value = assignee;
        this.filter.patchValue(assignee.label);
      });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
